// import React from "react";
// import { FAQCard } from "./FAQCard";

//export const FAQSection: React.FC = () => {
//   return (
//     <div className="text-white mt-4 px-5">
//       <h1 className="text-center pt-32 text-3xl font-medium font-poppins text-[#57c0af] mb-7">
//         <span className="text-white ">Frequently Asked Questions </span>  (FAQs)
//       </h1>

//       {/* What is Nuqi Section */}
//       <div className="p-8 bg-gradient-to-b from-[#1d1d1f] to-[#0d0d0d] max-w-[1100px] border-[#44464a] mx-auto border rounded-[61px] shadow-lg text-center mb-8 hover:!bg-black hover:!bg-none hover:shadow-[inset_0_0_20px_#0dd3ff] transition-all duration-300 ease-in-out">
//         <h2 className="text-lg font-semibold font-poppins mb-4 text-white">
//           What is Nuqi?
//         </h2>
//         <p className="text-sm font-poppins leading-6 text-gray-300  text-justify">
//           NUQI is an independent advisory platform, licensed by SEBI in India aimed at both first-time investors starting their investment journey and seasoned investors looking to diversify their portfolio.
//           NUQI deploys its in-house expertise to create portfolios tailored for specific Investor profile/ Investment Themes. NUQI has a team of qualified Investment Managers and select financial bodies to
//           independently screen the Universe of Ethical investments with both Domestic and International market exposures. The platform uses multiple criteria to make a selection of Stocks, ETFs, Mutual funds etc.
//           with Social Equity, Ethical operations, good Governance, and Environment protection as core investment themes which are considered as key elements aimed towards Sustainable Growth.

//         </p>
//       </div>

//       {/* Responsive FAQ Grid Layout */}
//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 max-w-[1100px] mx-auto ">
//         {/* FAQ Cards */}
//         <FAQCard
//           title="Why Invest through Nuqi?"
//           description="Access diverse portfolio featuring 1,500+ Indian stocks, along with ETFs and Mutual Funds.
// Access Ethical Mutual Funds for systematic investment planning and lumpsum.
// Pre-designed portfolios by qualified investment advisors for long term investing.
// "
//           customStyles="col-span-1 max-sm:mx-2 lg:col-span-1 lg:row-span-2  min-h-[200px] lg:h-[450px] border border-solid border-white border-opacity-40 rounded-[61px]   "
//         />

//         {/* <FAQCard
//           title={
//             <>
//               Does Nuqi require a minimum <br />
//               investment to get started?
//             </>
//           }
//           description={
//             <>
//               You can start your NUQI investment journey <br />
//               with USD 100 *
//             </>
//           }
//           customStyles="min-h-[200px] max-sm:mx-2  border border-solid border-white border-opacity-40 rounded-[50px]"
//         /> */}

//         <FAQCard
//           title="Does Nuqi perform RISK profiling to understand your investment goals?"
//           description="YES, NUQI performs RISK profiling for all clients"
//           customStyles="min-h-[200px] -ml-2 max-sm:mx-2  lg:mr-2 border border-solid border-white border-opacity-40 rounded-[50px] "
//         />

//         {/* <FAQCard
//           title="Where can I invest?"
//           description="With NUQI, now you have the option to invest in select financial products in International markets. NUQI takes a cautious approach and presently will only recommend investment instruments that have been pre-screened and carry returns as per your risk profile."
//           customStyles="col-span-1 lg:col-span-1 max-sm:mx-2 lg:row-span-2 min-h-[200px] lg:h-[430px] border border-solid border-white border-opacity-40 rounded-[61px]"
//         /> */}
//         <FAQCard
//           title={
//             <>
//               Where can I invest?
//             </>
//           }
//           description={
//             <>
//               With NUQI, now you have the option to invest in select financial products in International markets. NUQI takes a cautious approach and presently will only recommend investment instruments that have been pre-screened and carry returns as per your risk profile.
//             </>
//           }
//           customStyles="min-h-[200px] max-sm:mx-2  border border-solid border-white border-opacity-40 rounded-[50px]"
//         />
//         {/* <FAQCard
//           title={
//             <>
//               Can you set up Regular Investment Plan through the Nuqi app?
//             </>
//           }
//           description={
//             <>
//               Yes
//             </>
//           }
//           customStyles="min-h-[200px] max-sm:mx-2  border border-solid border-white border-opacity-40 rounded-[50px]"
//         /> */}

//         {/* <FAQCard
//           title={
//             <>
//               Can you buy fractional shares of stocks through Nuqi ?
//             </>
//           }
//           description={
//             <>
//               Yes
//             </>
//           }
//           customStyles="min-h-[200px] max-sm:mx-2  border border-solid border-white border-opacity-40 rounded-[50px]"
//         /> */}

//         <FAQCard
//           title={
//             <>
//               Can you set up Regular Investment Plan through the Nuqi app?
//             </>
//           }
//           description={
//             <>
//               Yes
//             </>
//           }
//           customStyles="min-h-[200px] max-sm:mx-2  border border-solid border-white border-opacity-40 rounded-[50px]"
//         />
//         <FAQCard
//           title={
//             <>
//               Does Nuqi offer investment options that consider social responsibility?
//             </>
//           }
//           description={
//             <>
//               YES, our Curated Equity Portfolios (CEP) are based on Ethical / Social & Sustainable ESS Principles.
//             </>
//           }
//           customStyles="min-h-[200px] max-sm:mx-2  border border-solid border-white border-opacity-40 rounded-[50px]"
//         />

//         <FAQCard
//           title="How Does it work?"
//           description="NUQI mobile app is soon available for Android and iOS devices and is free to download. You can register for a free account and browse the how-to-use instructions, market news, featured portfolios – all in the app itself. Once you have filled out the personal assessment questionnaire, the NUQI platform will assign an investor profile to you based on your risk appetite and recommend investment instruments accordingly. You can always change your risk profile by re-taking the questionnaire and NUQI will once again offer you a list of new recommendations suited to you."
//           customStyles="col-span-1 lg:col-span-1 lg:row-span-2 ml-2 lg:ml-0 min-h-[200px] lg:h-[450px] border border-solid border-white border-opacity-40 rounded-[61px] max-md:mr-2 "
//         />

//         <FAQCard
//           title="Are there live events to learn more about Nuqi's investment strategies?"
//           description="YES live online sessions / Global Event Participations on the cards."
//           customStyles="min-h-[200px] mr-2 lg:mr-0 border border-solid border-white border-opacity-40 rounded-[50px] max-md:ml-2"
//         />
//         {/* <FAQCard
//           title="Can you track your investments' performance live on the Nuqi app?"
//           description="YES our exhaustive portfolio view will, give you 360 Degree View on your investments."
//           customStyles="col-span-1 lg:col-span-1 lg:row-span-2 ml-2 lg:ml-0 min-h-[200px] lg:h-[450px] border border-solid border-white border-opacity-40 rounded-[61px] max-md:mr-2 "
//         /> */}

//         <FAQCard
//           title={
//             <>
//               Does Nuqi have resources to learn about investing for beginners?
//             </>
//           }
//           description={
//             <>
//               YES NUQI Ethosphere is our research library for enthusiastic ones.
//             </>
//           }
//           customStyles="min-h-[200px] max-sm:mx-2  border border-solid border-white border-opacity-40 rounded-[50px]"
//         />

//         <FAQCard
//           title="Can you adjust your investment plan based on changing risk tolerance?"
//           description="YES, you have the flexibility to change your RISK profile basis any material change in your circumstances."
//           customStyles="min-h-[200px] lg:mr-0 mr-2 border border-solid border-white border-opacity-40 rounded-[50px] max-md:ml-2"
//         />

//         <FAQCard
//           title="Does Nuqi collaborate with international brokers to offer a wider range of investment options?"
//           description="YES collaborations is one of the pillars for NUQI Wealth to provide.."
//           // customStyles="min-h-[200px] lg:mr-0 mr-2 border border-solid border-white border-opacity-40 rounded-[50px] max-md:ml-2"
//           customStyles="col-span-1 lg:col-span-1 lg:row-span-2 ml-2 lg:ml-0 min-h-[200px] lg:h-[450px] border border-solid border-white border-opacity-40 rounded-[61px] max-md:mr-2 "
//         />
//         <FAQCard
//           title="Does Nuqi leverage its associations to provide access to in-depth research reports?"
//           description="Yes IRIS & Ethosphere keep a watch."
//           customStyles="min-h-[200px] lg:mr-0 mr-2 border border-solid border-white border-opacity-40 rounded-[50px] max-md:ml-2"
//         />
//         {/* <FAQCard
//           title=" Does Nuqi offer investment options that consider social responsibility?"
//           description="YES, our Curated Equity Portfolios (CEP’s) are based on Ethical / Social & Sustainable ESS Principles."
//           customStyles="min-h-[200px] lg:mr-0 mr-2 border border-solid border-white border-opacity-40 rounded-[50px] max-md:ml-2"
//         /> */}

//         <FAQCard
//           title="Can you track your investment's performance live on the Nuqi app?"
//           description="YES, our exhaustive portfolio view will give you 360 Degree View on your investments."
//           customStyles="min-h-[200px] lg:mr-0 mr-2 border border-solid border-white border-opacity-40 rounded-[50px] max-md:ml-2"
//         />
//       </div>
//     </div>
//   );
// };
import React, { useState } from "react";
// import { FAQCard } from "./FAQCard";

const faqData: { title: string; description: React.ReactNode }[] = [
  {
    title: "  What is Nuqi?",
    description: `NUQI is an independent advisory platform, licensed by SEBI in India aimed at both first-time investors starting their investment journey and seasoned investors looking to diversify their portfolio. NUQI deploys its in-house expertise to create portfolios tailored for specific investor profiles and investment themes.The platform uses multiple criteria to make a selection of Stocks, ETFs, Mutual funds, etc.,
     with Social Equity, Ethical operations, Good Governance, and Environmental protection as core investment themes aimed towards Sustainable Growth.
     `,
  },
  {
    title: "Why Invest through Nuqi?",
    description:
      "Access diverse portfolios featuring 1,500+ Indian stocks, along with ETFs and Mutual Funds. Access Ethical Mutual Funds for systematic investment planning and lump sum. Pre-designed portfolios by qualified investment advisors for long-term investing.",
  },
  {
    title: "Are there any hidden charges or commissions?",
    description:
      "No, there are no hidden charges, fees, or commissions. We prioritize transparency, and all costs are clearly communicated upfront. If you have any questions, our team is here to help. Your trust matters to us!",
  },
  {
    title: "Does Nuqi perform RISK profiling to understand your investment goals?",
    description: "YES, NUQI performs RISK profiling for all clients.",
  },
  {
    title: "Where can I invest?",
    description:
      "With NUQI, now you have the option to invest in select financial products in International markets. NUQI takes a cautious approach and presently will only recommend investment instruments that have been pre-screened and carry returns as per your risk profile.",
  },
  {
    title: "Can you set up a Regular Investment Plan through the Nuqi app?",
    description: "Yes.",
  },
  {
    title: "Does Nuqi offer investment options that consider social responsibility?",
    description:
      "YES, our Curated Equity Portfolios (CEP) are based on Ethical / Social & Sustainable ESS Principles.",
  },
  {
    title: "How Does it Work?",
    description:
      "NUQI mobile app is soon available for Android and iOS devices and is free to download. Once you have filled out the personal assessment questionnaire, the NUQI platform will assign an investor profile to you based on your risk appetite and recommend investment instruments accordingly. You can always change your risk profile by re-taking the questionnaire and NUQI will once again offer you a list of new recommendations suited to you.",
  },
  {
    title: "Are there live events to learn more about Nuqi's investment strategies?",
    description:
      "YES, live online sessions and Global Event Participations are on the cards.",
  },
  {
    title: "Does Nuqi have resources to learn about investing for beginners?",
    description:
      "YES, NUQI Ethosphere is our research library for enthusiastic learners.",
  },
  {
    title: "Can you adjust your investment plan based on changing risk tolerance?",
    description:
      "YES, you have the flexibility to change your RISK profile based on any material change in your circumstances.",
  },
  {
    title: "Does Nuqi collaborate with international brokers to offer a wider range of investment options?",
    description:
      "YES, collaborations are one of the pillars for NUQI Wealth to provide broader investment options.",
  },
  {
    title: "Does Nuqi leverage its associations to provide access to in-depth research reports?",
    description: "Yes, IRIS & Ethosphere keep a watch on market trends and investment insights.",
  },
  {
    title: "Can you track your investment's performance live on the Nuqi app?",
    description:
      "YES, our exhaustive portfolio view will give you a 360-degree view of your investments.",
  },
  {
    title: "Is it compulsory for the investors to use the new handle only?",
    description:
      "The investors can choose their preferred mode of payment, such as UPI, IMPS, NEFT, RTGS, or Cheques. If an investor opts to use UPI for the payment to registered intermediaries, then they have to do so only using the new UPI ID handle allotted to registered intermediaries.",
  },
  {
    title: "What should I check while making payment using the new UPI IDs/ QR Codes?",
    description: (
      <div>
        <p className="mb-2">Investors need to keep following things into consideration:</p>
        <ol className="list-decimal pl-4 space-y-1">
          <li>The UPI ID should properly show the name of the intermediary, followed by the short abbreviation of their category for example "brk" for Brokers, "mf" for Mutual Funds, to the left of the "@" character.</li>
          <li>On the right side of the "@", the new and exclusive handle <strong>"@valid"</strong> should be present, followed by the bank name.</li>
          <li>On the confirmation screen, the app should show a white thumbs-up icon inside a green triangle.</li>
          <li>The QR code generated using the utility will have a white thumbs-up icon inside a green triangle. it will also display the UPI ID just below the QR code.</li>
        </ol>
      </div>
    ),
  },
  {
    title: "Do investors also need to obtain new UPI handles to transact in the securities market?",
    description:
      "No, the new UPI IDs are only for the intermediaries to obtain and investor can continue to use their existing UPI IDs.",
  },
  {
    title: "Whom to approach if my transaction/ payment fails with the new UPI ID?",
    description:
      "The secure validated UPI ID of intermediaries will use the same banking channel as the earlier generic UPI handles. In case of any technical difficulty, investors are requested to approach their respective bank.",
  },
];

export const FAQSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    // <div className="text-white mt-4 px-5">
    //   <h1 className="text-center pt-32 text-3xl font-medium font-poppins text-[#57c0af] mb-7">
    //     <span className="text-white">Frequently Asked Questions </span> (FAQs)
    //   </h1>

    //   {/* What is Nuqi Section */}
    //   <div className="p-8 bg-gradient-to-b from-[#1d1d1f] to-[#0d0d0d] max-w-[1100px] border-[#44464a] mx-auto border rounded-[50px] shadow-lg text-center mb-2 hover:!bg-black hover:!bg-none hover:shadow-[inset_0_0_20px_#0dd3ff] transition-all duration-300 ease-in-out">
    //     <h2 className="text-lg font-semibold font-poppins mb-4 text-white">
    //       What is Nuqi?
    //     </h2>
    //     <p className="text-sm font-poppins leading-6 text-gray-300 text-center">
    //       NUQI is an independent advisory platform, licensed by SEBI in India aimed at both first-time investors
    //       starting their investment journey and seasoned investors looking to diversify their portfolio. NUQI
    //       deploys its in-house expertise to create portfolios tailored for specific investor profiles and
    //       investment themes. The platform uses multiple criteria to make a selection of Stocks, ETFs, Mutual funds, etc.,
    //       with Social Equity, Ethical operations, Good Governance, and Environmental protection as core investment themes aimed towards Sustainable Growth.
    //     </p>
    //   </div>

    //   {/* FAQ Cards Grid */}
    //   <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 max-w-[1100px] mx-auto">
    //     {/* Large Card Spanning Two Rows */}
    //     {/* <FAQCard
    //       title="Why Invest through Nuqi?"
    //       description="Access diverse portfolios featuring 1,500+ Indian stocks, along with ETFs and Mutual Funds. Access Ethical Mutual Funds for systematic investment planning and lump sum. Pre-designed portfolios by qualified investment advisors for long-term investing."
    //       // customStyles="lg:row-span-2 h-[calc(100%)]" // ✅ Fix row span height issue
    //     /> */}
    //     {/* <FAQCard
    //       title="Are there any hidden charges or commissions?"
    //       description="No, there are no hidden charges, fees, or commissions. We prioritize transparency, and all costs are clearly communicated upfront. If you have any questions, our team is here to help. Your trust matters to us!"
    //       // customStyles="lg:row-span-2 h-[calc(100%)]" // ✅ Fix row span height issue
    //     /> */}

    //     {/* Standard Cards */}
    //     {/* <FAQCard title="Does Nuqi perform RISK profiling to understand your investment goals?" description="YES, NUQI performs RISK profiling for all clients." />
    //     <FAQCard title="Where can I invest?" description="With NUQI, now you have the option to invest in select financial products in International markets. NUQI takes a cautious approach and presently will only recommend investment instruments that have been pre-screened and carry returns as per your risk profile." /> */}

    //     {/* Standard Row */}
    //     {/* <FAQCard title="Can you set up a Regular Investment Plan through the Nuqi app?" description="Yes." />
    //     <FAQCard title="Does Nuqi offer investment options that consider social responsibility?" description="YES, our Curated Equity Portfolios (CEP) are based on Ethical / Social & Sustainable ESS Principles."/> */}

    //     {/* Large Card Spanning Two Rows */}
    //     {/* <FAQCard
    //       title="How Does it Work?"
    //       description="NUQI mobile app is soon available for Android and iOS devices and is free to download. Once you have filled out the personal assessment questionnaire, the NUQI platform will assign an investor profile to you based on your risk appetite and recommend investment instruments accordingly. You can always change your risk profile by re-taking the questionnaire and NUQI will once again offer you a list of new recommendations suited to you."
    //       customStyles="lg:row-span-2 h-[calc(100%)]" // ✅ Fix row span height issue
    //     /> */}

    //     {/* Standard Row */}
    //     {/* <FAQCard title="Are there live events to learn more about Nuqi's investment strategies?" description="YES, live online sessions and Global Event Participations are on the cards." />
    //     <FAQCard title="Does Nuqi have resources to learn about investing for beginners?" description="YES, NUQI Ethosphere is our research library for enthusiastic learners." />
    //     <FAQCard title="Can you adjust your investment plan based on changing risk tolerance?" description="YES, you have the flexibility to change your RISK profile based on any material change in your circumstances." /> */}

    //     {/* Large Card Spanning Two Rows */}
    //     {/* <FAQCard
    //       title="Does Nuqi collaborate with international brokers to offer a wider range of investment options?"
    //       description="YES, collaborations are one of the pillars for NUQI Wealth to provide broader investment options."
    //       customStyles="lg:row-span-2 h-[calc(100%)]" // ✅ Fix row span height issue
    //     /> */}

    //     {/* Standard Row */}
    //     {/* <FAQCard title="Does Nuqi leverage its associations to provide access to in-depth research reports?" description="Yes, IRIS & Ethosphere keep a watch on market trends and investment insights." />
    //     <FAQCard title="Can you track your investment's performance live on the Nuqi app?" description="YES, our exhaustive portfolio view will give you a 360-degree view of your investments."
    //     /> */}
    //   </div>
    // </div>

    <div className="text-white mt-4 px-5 w-full">
      <h1 className="text-center pt-32 text-3xl text-[#57c0af] mb-7">
        <span className="text-white text-3xl md:text-4xl font-semibold font-plus-jakarta font-sans">Frequently Asked Questions </span> (FAQs)
      </h1>

      {/* Accordion Wrapper: two columns with 7 items each */}
      <div className="w-full min-h-full mx-auto grid gap-6 grid-cols-1 md:grid-cols-2">

        {/* First column: items 0-8 */}
        <div className="space-y-2">
          {faqData.slice(0, 9).map((faq, idx) => {
            const index = idx; // global index for state
            return (
              <div
                key={index}
                className="p-2 md:p-4 bg-gradient-to-b from-zinc-900 to-black border border-zinc-700 rounded-lg shadow-lg transition-all duration-300 ease-in-out hover:border-[#57c0af] hover:shadow-[#57c0af]/20"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex justify-between items-center text-left"
                  aria-expanded={openIndex === index}
                  aria-controls={`faq-content-${index}`}
                >
                  <h2 className="text-sm font-normal text-white pr-4">{faq.title}</h2>
                  <span
                    className={`text-[#57c0af] text-2xl font-light transition-transform duration-300 flex-shrink-0 ${openIndex === index ? "rotate-45" : "rotate-0"
                      }`}
                  >
                    +
                  </span>
                </button>

                <div
                  id={`faq-content-${index}`}
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? "max-h-96 mt-4 opacity-100" : "max-h-0 opacity-0"
                    }`}
                >
                  <div className="text-[14px] leading-6 text-gray-300">{faq.description}</div>
                </div>
              </div>
            );
          })}
        </div>
        {/* Second column: items 9-17 */}
        <div className="space-y-2 mt-0 p-0 gap-0">
          {faqData.slice(9).map((faq, idx) => {
            const index = idx + 9; // offset for second column
            return (
              <div
                key={index}
                className="p-2 md:p-4 bg-gradient-to-b from-zinc-900 to-black border border-zinc-700 rounded-lg shadow-lg transition-all duration-300 ease-in-out hover:border-[#57c0af] hover:shadow-[#57c0af]/20"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex justify-between items-center text-left"
                  aria-expanded={openIndex === index}
                  aria-controls={`faq-content-${index}`}
                >
                  <h2 className="text-sm font-normal text-white pr-4">{faq.title}</h2>
                  <span
                    className={`text-[#57c0af] text-2xl font-light transition-transform duration-300 flex-shrink-0 ${openIndex === index ? "rotate-45" : "rotate-0"
                      }`}
                  >
                    +
                  </span>
                </button>

                <div
                  id={`faq-content-${index}`}
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? "max-h-96 mt-4 opacity-100" : "max-h-0 opacity-0"
                    }`}
                >
                  <div className="text-[14px] leading-6 text-gray-300">{faq.description}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
